var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 17.2969,
    width: 1.68222,
    height: 12.9189,
    rx: 0.841109,
    transform: "rotate(135 10.5 17.2969)",
    fill: "#3A3A3A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00488,
    y: 0.511719,
    width: 1.68222,
    height: 12.4983,
    rx: 0.841109,
    transform: "rotate(45 9.00488 0.511719)",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.3337356b88c6ec0cbf0b205bb12f3f54.svg";
export { ForwardRef as ReactComponent };